<template>
    <div class="invoicedetails">
      <div class="invoicevalue">
        <span >{{$t('Cover.ShowCover.INVOICE_NUMBER_FIELD_NAME')}}</span>
        <span style="font-size: 18px;">{{cover.invoice.number}}</span>
      </div>
      <div class="coverstatus">
          <span v-bind:class="cover.invoice.statusCode.toLowerCase()">
              <p class="centerTextDetail">{{ cover.invoice.status}}</p>
          </span>
          <span class="claimstatus" v-if="cover.details.originTab === 'Claimed' && !userInfos.claimExtendedForm">
              <p class="centerText"> <i> {{ cover.claim.status}} </i> </p>
          </span>
      </div>
      <div class="smalltext greytext">
        <span>{{cover.rejectionReason}}</span>
      </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('cover', ['cover']),
    ...mapState('userdetails', ['userInfos'])
  }
}
</script>

<style>
.coverstatus {
  display: inline-flex;
  margin-top: 5px;
}
.claimstatus {
  margin-left: 14px
}
</style>
